import { shiftMonths, ymdInTimezone } from '@loop3/dates';
const TEAM_TIMEZONE = 'America/Argentina/Buenos_Aires';
/** Planned team spans for one client, or every client when `clientId` is omitted. Never carries hours. */
export async function listClientTeam(db, clientId) {
    const { data, error } = await db.rpc('client_team', clientId ? { p_client_id: clientId } : {});
    if (error)
        throw new Error(error.message);
    return (data ?? []);
}
/** The current `'YYYY-MM'` in Buenos Aires, the month the plan is read against. */
export function currentMonth(now = new Date()) {
    return ymdInTimezone(now, TEAM_TIMEZONE).slice(0, 7);
}
const prevMonth = (m) => shiftMonths(`${m}-01`, -1).slice(0, 7);
/** People planned on the client in `month`, with the account owner merged in first. */
export function currentTeam(spans, ownerId, month) {
    // 'YYYY-MM' strings compare in calendar order.
    const covers = (s, m) => s.from_month <= m && m <= s.to_month;
    const byPerson = new Map();
    for (const s of spans)
        byPerson.set(s.person_id, [...(byPerson.get(s.person_id) ?? []), s]);
    const members = [];
    for (const [personId, own] of byPerson) {
        const active = own.filter((s) => covers(s, month));
        if (!active.length)
            continue;
        let since = month;
        while (own.some((s) => covers(s, prevMonth(since))))
            since = prevMonth(since);
        members.push({ personId, roles: [...new Set(active.map((s) => s.role_name))].sort(), since, isOwner: personId === ownerId });
    }
    if (ownerId && !members.some((m) => m.isOwner))
        members.push({ personId: ownerId, roles: [], since: null, isOwner: true });
    return members.sort((a, b) => Number(b.isOwner) - Number(a.isOwner) || (a.since ?? '').localeCompare(b.since ?? '') || a.personId.localeCompare(b.personId));
}
